/**
 * Optional static public pricing config for MCP widget (no apiClient).
 */

import { createContext, useContext } from 'react';
import type { PublicSubscriptionConfig } from '../types/publicSubscriptionConfig';

export const PublicSubscriptionConfigOverrideContext =
  createContext<PublicSubscriptionConfig | null>(null);

/**
 * Returns injected config when the MCP widget (or tests) provided one.
 */
export function usePublicSubscriptionConfigOverride(): PublicSubscriptionConfig | null {
  return useContext(PublicSubscriptionConfigOverrideContext);
}
